import { render, staticRenderFns } from "./PlatformPriorityIcon.vue?vue&type=template&id=16cc50d6&lang=pug&"
import script from "./PlatformPriorityIcon.vue?vue&type=script&lang=js&"
export * from "./PlatformPriorityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports